import React, {Component} from 'react';
import PropTypes from 'prop-types';
import cN from 'classnames';
import isInteger from 'lodash/isInteger';

// noUiSlider
import noUiSlider from 'nouislider';
import 'nouislider/distribute/nouislider.min.css';

/**
 * A convenient range component that renders to a materialize row.
 */
class Range extends Component {

    static DISCRETE = 'discrete';
    static CONTINUOUS = 'continuous';

    static POSITION_RANDOM = 'random';
    static POSITION_CENTERED = 'centered';

    render() {
        const {showHandle} = this.props;

        return (
            <div className={cN('noUi-range', {'no-handle': !showHandle})} ref={this.ref} />
        );
    }

    /**
     * Updates the value of the slider that was passed in new props
     */
    componentWillUpdate(nextProps) {
        const {value} = nextProps;

        this.slider.noUiSlider.set(value);
    }

    /**
     * Initializes and Configures a NoUiSlider
     * see https://refreshless.com/nouislider/ for the docs
     */
    ref = node => {
        if (!node) return;

        this.slider = node;

        const {min, max, step, value, continuity, showNumbers, onChange} = this.props;

        const isDiscrete = continuity === Range.DISCRETE;

        const options = isDiscrete ? {
            pips: {
                mode: 'steps',
                density: 100 / Math.abs(max - min) * step,
                format: showNumbers ? null :{to: () => '', from: () => ''},
            },
            format: {to: Math.round, from: Math.round},
        } : {};

        noUiSlider.create(this.slider, {
            start: isInteger(value) ? value : this.defaultValue,
            range: {
                min,
                max,
            },
            step: isDiscrete ? step : 1,
            ...options,
        }).on('change', value => {
            const event = {
                currentTarget: {value},
            };
            onChange(event);
        });
    };

    /**
     * Returns the default value to set if no value was provided
     */
    get defaultValue() {
        const {min, max, position} = this.props;

        if (position === Range.POSITION_CENTERED) return Math.floor((min + max) / 2);

        return Math.floor(Math.random() * ((max - min) + 1)) + min;
    }
}

Range.propTypes = {
    value: PropTypes.number,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    step: PropTypes.number,
    continuity: PropTypes.oneOf([Range.DISCRETE, Range.CONTINUOUS]),
    showNumbers: PropTypes.bool,
    showHandle: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    position: PropTypes.oneOf([Range.POSITION_CENTERED, Range.POSITION_RANDOM]),
};

Range.defaultProps = {
    step: 1,
    value: 0,
    continuity: Range.CONTINUOUS,
    position: Range.POSITION_CENTERED,
    showNumbers: true,
    showHandle: true,
};

export default Range;



// WEBPACK FOOTER //
// ./scripts/components/Range.js